exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".molgenis-table-container{margin-bottom:10px;overflow:auto;white-space:nowrap}.molgenis-table{width:100%;margin-bottom:10px}.molgenis-table thead th.compact{width:1px;white-space:nowrap}.molgenis-table .show-popover,.table-hover tbody tr{cursor:pointer}.molgenis-table .table-hover tr:hover{background-color:#7cbad1}.molgenis-table .popover-content{word-wrap:break-word}.molgenis-table{border-style:none}.molgenis-table tbody>tr>td:not(.expanded-left):not(.expanded-right),.molgenis-table thead>tr>th:not(.expanded-left):not(.expanded-right){border-left-style:none;border-right-style:none}.molgenis-table tbody>tr:last-child>td{border-bottom-style:none}.molgenis-table td.expanded-left,.molgenis-table th.expanded-left{border-right-style:none}.molgenis-table td.expanded-right,.molgenis-table th.expanded-right{border-left-style:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/main/javascript/modules/react-components/css/Table.css
// module id = 348
// module chunks = 1